import { lazy } from 'react';

const page = lazy(() => import(/* webpackChunkName: 'Meetings' */ '.'));

export default page;
